import {
    CellFormatterService,
    END_STATE_CLASS,
    TableOptions
} from '../common/datatable';
import { DataType } from '../data-type';
import { TranslationService } from '../services/translation.service';
import { addAuditColumnsToOptions } from '@common/datatable/utils';

export class TaskTableOptions {

    options: TableOptions;

    constructor(
        private cellFormatterService: CellFormatterService,
        private translationService: TranslationService
    ) {
        this.options = addAuditColumnsToOptions(cellFormatterService)(this.getDefaultOptions());
    }

    getDefaultOptions(): TableOptions {
        return {
            csvFileName: 'tasks.csv',
            enableDeleteColumn: true,
            enableDetailColumn: true,
            enableDraggable: true,
            dragOnlyActiveRows: true,
            enableSelectable: true,
            rowClass: (params: any) => {
                const row = params.data;

                const classes: string[] = [];
                if (row && row.IsActive !== true) {
                    classes.push(END_STATE_CLASS);
                }
                return classes;
            },
            columns: [
                {
                    displayName: 'Name', field: 'TaskName'
                },
                {
                    displayName: 'Description', field: 'Description'
                },
                {
                    displayName: 'Type', field: 'cv_TaskType.TaskType',
                    formatter: (row: any, value: any) => {
                        return value ? this.translationService.translate(value) : '';
                    }
                },
                {
                    displayName: 'Active', field: 'IsActive',
                    formatter: this.cellFormatterService.booleanFormatter,
                    exportFormatter: this.cellFormatterService.booleanExportFormatter,
                    maxWidth: 80,
                    visible: false
                },
                {
                    displayName: 'Effort', field: 'Effort', visible: false
                },
                {
                    displayName: 'Flags',
                    field: 'FlagsSortable',
                    visible: false
                }
            ]
        };
    }
}
